import { z } from 'zod'

export const Pagination = z.object({
    next: z.string().optional(),
})
